import { render } from "./margebeneficiaire.vue?vue&type=template&id=591bb978&scoped=true"
import script from "./margebeneficiaire.vue?vue&type=script&lang=js"
export * from "./margebeneficiaire.vue?vue&type=script&lang=js"

import "./margebeneficiaire.vue?vue&type=style&index=0&id=591bb978&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591bb978"]])

export default __exports__